export enum HeroBannerCopyPlacement {
  TOPLEFT = 'top-0 left-0',
  TOPMIDDLE = 'top-0 left-1/2 -translate-x-1/2',
  TOPRIGHT = 'top-0 right-0',
  LEFT = 'top-1/2 left-0 -translate-y-1/2',
  MIDDLE = 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
  RIGHT = 'top-1/2 right-0 -translate-y-1/2',
  BOTTOMLEFT = 'bottom-0 left-0',
  BOTTOMMIDDLE = 'bottom-0 left-1/2 -translate-x-1/2',
  BOTTOMRIGHT = 'bottom-0 right-0',
}
